module.exports = __webpack_public_path__ + "img/gallery14.2fe7ce2.jpg";